import React from 'react';
import { useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useTheme } from '../../contexts/ThemeContext';
import Navbar from './Navbar';
import KeyboardShortcuts from '../UI/KeyboardShortcuts';

const Layout = ({ children }) => {
  const { theme } = useTheme();
  const location = useLocation();

  // Hide navbar on dashboard and auth routes
  const isDashboardRoute = location.pathname.startsWith('/dashboard') ||
    location.pathname.startsWith('/monitors') ||
    location.pathname.startsWith('/settings') ||
    location.pathname.startsWith('/monitor/');

  const isAuthRoute = location.pathname === '/login' ||
    location.pathname === '/register' ||
    location.pathname === '/forgot-password' ||
    location.pathname.startsWith('/reset-password') ||
    location.pathname.startsWith('/verify-email');

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-black transition-colors duration-200">
      {!isDashboardRoute && !isAuthRoute && <Navbar />}
      <main className="flex-1">
        {children}
      </main>

      {/* Keyboard shortcuts helper */}
      <KeyboardShortcuts />

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: theme === 'dark' ? '#1f2937' : '#fff',
            color: theme === 'dark' ? '#f9fafb' : '#374151',
            boxShadow: theme === 'dark'
              ? '0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.2)'
              : '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            border: theme === 'dark' ? '1px solid #374151' : '1px solid #e5e7eb',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: theme === 'dark' ? '#1f2937' : '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: theme === 'dark' ? '#1f2937' : '#fff',
            },
          },
        }}
      />
    </div>
  );
};

export default Layout;
